import { StatusConfig, StatusState } from '@gripp/shared-logic';
import { FC } from 'react';
import { RoutineComponentProps } from '../types';

export type StatusComponentProps = RoutineComponentProps<
  StatusConfig,
  StatusState
>;

export type StatusComponent = FC<StatusComponentProps>;

export const OpenEndedResponse = 'openEndedResponse';
